import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { getBanks } from '../../store/Lookup/lookupSlice';
import { GetBankList } from '../../store/NTX/Banks/banksSlice';
import { useTranslation } from 'react-i18next';

const useGetBanks = () => {
  const { i18n } = useTranslation();

  const dispatch = useDispatch();

  const { BanksList: Banks, loading, error } = useSelector((state) => state.Banks);

  useEffect(() => {
    // dispatch(getBanks());
    dispatch(GetBankList());
  }, []);

  const BanksOptions =
    Banks &&
    Banks?.map((item) => ({
      value: item.id,
      label: i18n.language === 'en' ? item.name : item.name2,
    }));

  return { Banks, BanksOptions, loading, error };
};

export default useGetBanks;
